import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogCookieConfirm } from '../dialogs/dialog-cookie-confirm/dialog-cookie-confirm.component';
import { MyCookieService } from '../../../services/my-cookie.service';

@Component({
  selector: 'impostazione-cookie',
  templateUrl: './impostazione-cookie.component.html',
  styleUrls: ['./impostazione-cookie.component.css']
})
export class ImpostazioneCookieComponent {
  myCookieService: MyCookieService;
  constructor(@Inject(MyCookieService) myCookieService: MyCookieService,
    private dialog: MatDialog) 
  {
    this.myCookieService = myCookieService;
  }

  open(){
    let dialogRef = this.dialog.open(DialogCookieConfirm, {disableClose: true});
    dialogRef.afterClosed().subscribe(
      () => {
        if(this.myCookieService.change === true){
          this.myCookieService.reloaded = true;
          location.reload();
        }
      }
    );
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/impostazione-cookie/impostazione-cookie.component.ts